export default "__VITE_ASSET__c796cc58__"